import { Paginated } from '../api/types';

export const selectRecords = <DataT>(paginatedData: Paginated<DataT>) =>
  paginatedData.records;
